import React from 'react'
// import config from '../../config'
import format from '../../helpers/format'
// import { Link, LinkIcon } from '../'

const EsgConfig = {
  esgNamesLabels: [
    {
      label: 'Civilian firearms',
      value: 'wff_civ_weight',
    },
    // {
    //   label: 'Gun manufacturers',
    //   value: 'gm_weight',
    // },
    // {
    //   label: 'Major gun retailers',
    //   value: 'gr_weight',
    // },
  ],
  esgOptions: {
    wff_civ_weight: {
      id: 'wff_civ_weight',
      icon: 'icons_step4',
      fieldLabel: 'wff_civ_weight',
      benchLabel: 'wff_civ_weight',
      valueLabel: 'Civilian firearm',
      direction: 'ascending',
      page: 'civilian-firearm-investments',
      label: 'in civilian firearms',
      units: null,
      unitsExpanded: null,
      diffGood: (diff) => (diff < 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
      moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
      format : (val) => format.perc(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (val === 0) {
          return (
            <span>
              <strong>the same amount</strong> invested in civilian firearm companies
            </span>
          )
        }
        return (
          <span>
            <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in civilian firearm companies
          </span>
        )
      }
    },
    // gm_weight: {
    //   id: 'gm_weight',
    //   icon: 'icons_step4',
    //   fieldLabel: 'gm_weight',
    //   benchLabel: 'gm_weight',
    //   valueLabel: 'Gun manufacturers',
    //   direction: 'ascending',
    //   page: 'gun-manufacturer-investments',
    //   label: 'in gun manufacturers',
    //   units: null,
    //   unitsExpanded: null,
    //   diffGood: (diff) => (diff < 0),
    //   diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
    //   moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
    //   format : (val) => format.perc(val),
    //   formatExpanded: (val, moreLess, postiveNegative, url) => {
    //     if (val === 0) {
    //       return (
    //         <span>
    //           <strong>the same amount</strong> invested in gun manufacturers
    //         </span>
    //       )
    //     }
    //     return (
    //       <span>
    //         <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in gun manufacturers
    //       </span>
    //     )
    //   }
    // },
    // gr_weight: {
    //   id: 'gr_weight',
    //   icon: 'icons_step4',
    //   fieldLabel: 'gr_weight',
    //   benchLabel: 'gr_weight',
    //   valueLabel: 'Major gun retailers',
    //   direction: 'ascending',
    //   page: 'gun-retailers-investments',
    //   label: 'in major gun retailers',
    //   units: null,
    //   unitsExpanded: null,
    //   diffGood: (diff) => (diff < 0),
    //   diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
    //   moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
    //   format : (val) => format.perc(val),
    //   formatExpanded: (val, moreLess, postiveNegative, url) => {
    //     if (val === 0) {
    //       return (
    //         <span>
    //           <strong>the same amount</strong> invested in major gun retailers
    //         </span>
    //       )
    //     }
    //     return (
    //       <span>
    //         <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in major gun retailers
    //       </span>
    //     )
    //   }
    // },
  }
}

export default EsgConfig